import {
  isInvestor,
  isInstitutional,
} from '../authentication/authentication-manager.js'
import { isLocal, isPreview } from './index.js'

export function getRelativeBasePath() {
  let path = ''

  if (isLocal()) {
    if (window.location.href.indexOf('/cti-site/cti-advisorspa') >= 0) {
      path = '/cti-site/cti-advisorspa'
    } else if (window.location.href.indexOf('/cti-site/cti-advisor') >= 0) {
      path = '/cti-site/cti-advisor'
    } else if (window.location.href.indexOf('/cti-site/cti-investorspa') >= 0) {
      path = '/cti-site/cti-investorspa'
    } else if (window.location.href.indexOf('/cti-site/cti-investor') >= 0) {
      path = '/cti-site/cti-investor'
    } else if (window.location.href.indexOf('/cti-site/cti-blog') >= 0) {
      path = '/cti-site/cti-advisor'
    } else if (window.location.href.indexOf('/cti-site/cti-institutional') >= 0) {
      path = '/cti-site/cti-institutional'
    }
  }

  path = isInvestor()
    ? '/investor'
    : isInstitutional()
      ? '/institutional'
      : path

  return path
}

export function getAbsolutePath(includeSite) {
  let path = getRelativeBasePath()

  path = includeSite ? window.location.origin + path : window.location.origin

  return path
}

export function getRelativeServiceBasePath() {
  let path = ''

  if (isLocal()) {
    if (window.location.href.indexOf('/cti-site/cti-advisor') >= 0) {
      path = '/cti-site/cti-advisor'
    } else if (window.location.href.indexOf('/cti-site/cti-investor') >= 0) {
      path = '/cti-site/cti-advisor'
    } else if (window.location.href.indexOf('/cti-site/cti-blog') >= 0) {
      path = '/cti-site/cti-advisor'
    }
  }

  return path
}

export function getRelativeAssetBasePath() {
  let path = '/binaries'

  if (isLocal()) {
    if (window.location.href.indexOf('/cti-site/cti-advisor') >= 0) {
      path = '/cti-site/cti-advisor/binaries'
    } else if (window.location.href.indexOf('/cti-site/cti-investor') >= 0) {
      path = '/cti-site/cti-advisor/binaries'
    } else if (window.location.href.indexOf('/cti-site/cti-blog') >= 0) {
      path = '/cti-site/cti-advisor/binaries'
    }
  }

  return path
}

export function getPreviewPath() {
  return isPreview() ? '/preview' : ''
}
